import { render, staticRenderFns } from "./SolutionCard.vue?vue&type=template&id=3c403028&scoped=true"
import script from "./SolutionCard.vue?vue&type=script&lang=js"
export * from "./SolutionCard.vue?vue&type=script&lang=js"
import style0 from "./SolutionCard.vue?vue&type=style&index=0&id=3c403028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c403028",
  null
  
)

export default component.exports